export default "__VITE_ASSET__$UXo2WD$__"